module.exports = __webpack_public_path__ + "static/media/kz.6108408d.svg";